// TODO - Documentar
import ForwardsTable  from "./ForwardsTable"



export const Calculator = ({numberOfColumns = 2, shortColumnNames=false, rowsToShow}) => {
    return (
        <div>
            <ForwardsTable numberOfColumns={numberOfColumns} shortColumnNames={shortColumnNames} rowsToShow={rowsToShow}/>
        </div>
    );
};

